import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import { useIsFuboSportsAvailable } from 'src/modules/hooks/useIsFuboSportsAvailable'
import { getFuboSportsCBBPlans } from 'src/constants/planData/fuboSportsCBBPlans'

export default (props) => {
  const { isAvailable } = useIsFuboSportsAvailable()

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/CBB_on_ACC_2021_LP_10s.mp4'}
      title="Stream college hoops on ACC Network"
      subtitle="Get live games, news and more"
      networkSet="basketball"
      customNetworks={['acc']}
      league="nba"
      showRSN={true}
      sportId={sportIds.Basketball}
      leagueId={leagueIds["Men's NCAA Basketball"]}
      hasPlanCards={isAvailable}
      plans={isAvailable ? getFuboSportsCBBPlans() : []}
    />
  )
}
